'use client';

import { signIn, useSession } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useTeams } from '../lib/hooks/useTeams';
import LoadingBouncer from '../lib/loading/LoadingBouncer';
import { useRouter } from '../lib/routing/routing';

export const PopupPageContent = () => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const { authentication, isValidating } = useTeams();
	const { status } = useSession();

	const callbackUrl = searchParams?.get('callbackUrl') || '/';

	useEffect(() => {
		if (isValidating || status === 'loading') {
			return;
		}
		// If non-Teams && session exists - close popup or redirect to root as a fallback
		if (!authentication && status === 'authenticated') {
			window.close();
			router.replace(callbackUrl);
			return;
		}

		// If Teams && session exists - notify main frame
		if (authentication && status === 'authenticated') {
			// @ts-expect-error
			authentication.notifySuccess();
			return;
		}

		// No session - try to log in
		if (status === 'unauthenticated') {
			signIn('azure-ad').catch(() => {});
		}
	}, [isValidating, status, router, authentication, callbackUrl]);

	return <LoadingBouncer />;
};
